import { GetStartedTaskStatus } from '../store/schema/GetStartedTaskStatus';
import { getStartedStore } from '../store/store';
export function getIncompleteGetStartedTasksNumber() {
    var store = getStartedStore();
    if (store.tasks) {
        return store.tasks
            .filter(function (task) { return task.status === GetStartedTaskStatus.Incomplete; })
            .map(function (task) { return task.identity; }).length;
    }
    return null;
}
//# sourceMappingURL=getIncompleteGetStartedTasksNumber.js.map